import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/document-center`;
export const byMoveUri = `${baseUri}/moves/:moveId/:type`;
export const createScreenshotUri = `${baseUri}/screenshot`;
export const templateMappingsUri = `${baseUri}/template-mappings`;
export const transactionsTemplateUri = `${baseUri}/transactions/:transactionId/templates/:templateMappingId`;
